export const iconUrl = 'https://www.jjoktv.com/api/file/download'

export interface searchQueryStringTypes {
    search_type?: string
    keyword?: string
    page: number
    page_count: number
    [key: string]: any;
}
export const searchQueryStringTypesDefault = {
    search_type: "",
    keyword: "",
    page: 1,
    page_count: 10
}
export interface ListSportsMatchType {
    icon: string
    schedule_date: string
    schedule_time: string
    description: string
    name: string
    status: number
    type: string
    img: string
    url: string
}

export interface YoutubeListType extends highlightType {
    id: number
    title: string
    summary: string
    thumbnail: string
    video_id: string
    author_name: string
    league_info: string
    create_dt: string
    update_dt: string
}

interface highlightType {
    hometeam_score: number
    awayteam_score: number
    hometeam_name: string
    awayteam_name: string
    score_diff: number
}

export interface VerifiedListType {
    id: number
    title: string
    author: number
    author_name: string
    grade: number
    views: number
    likes: number
    verifiedsite_image: string
    verifiedsite_url: string
    verifiedsite_info: string
    event_info: string
    signup_event_info: string
    create_dt: string
    update_dt: string
    is_liked: boolean
}

export interface PointListType {
    id: number
    product_type: number
    name: string
    image: string
    point_cost: number
    update_user: string
    user: number
    username: string
    create_dt: string
    update_dt: string
    coupon: string
}

export interface EventMatchListType {
    board_status                 : string,
    id                 : number,
    title              : string,
    content            : string,
    sports_type        : number,
    views              : number,
    create_dt          : string,
    update_dt          : string,
    author_name        : string,
    update_author_name : string | null,
    isvoid             : number,
    isvoid_text        : string,
    prize_money        : number,
    is_paid            : boolean,
    bet_close_time     : string,
    is_user_joined     : boolean,
    markets            : EventMatchMarketTypes[],
    betting_history    : EventMatchBettingHistoryTypes[],
    top_image_type     : string,
    top_image_text     : string,
}
export interface EventMatchMarketTypes {
    id                 : number
    event_board        : number
    event_type         : number
    event_type_display : string
    handicap           : string
    selections: EventMatchSelectionsTypes[]
    result             : number
}
export interface EventMatchSelectionsTypes {
    id       : number
    bet_name : string
}
export interface EventMatchBettingHistoryTypes {
    id: number,
    event_board: number,
    event_type: number,
    event_type_display: string,
    selections: number[],
    status: string[],
    result: string,
    user: number,
    username: string,
    create_dt: string,
    ispaid: number,
    ispaid_text: string,
    paid_amount: number
}
export interface EventBoardListType {
    id: number
    title: string
    content: string
    views: number
    like_count: number
    create_dt: string
    update_dt: string
    author_username: string
    update_author_username: string
    is_liked: boolean
}
export interface EventRankingListType {
    title: string
    total_count: number
    objects: EventRankingObjectType[]
}

export interface EventRankingObjectType {
    id: number
    ranking_type: number
    ranking_info: EventRankingInfoType[]
}
export interface EventRankingInfoType {
    username: string
    total: number
    no: number
}

export interface CommentListType {
    id:number
    author_name: string
    content: string
    create_dt: string
    is_author: string
    modify_count: number
    update_dt: string
    profile_image: string
}

export interface BoardViewTypes {
    author_name: string
    comment_count: number
    comments: CommentListType[]
    content: string
    create_dt: string
    id: number
    is_author: boolean
    like_count: number
    thumbnail: string
    title: string
    views: number
    pinned_order:number|null
}

export interface SpeicalFactListType {
    title: string
    sport_type: string
    content: string
    author_name: string
    is_active: string
}

export interface SpeicalAdvanceListType {
    league_name: string
    game_time: string
    home_team: string
    home_player: string
    away_team: string
    away_player: string
    author_name: string
    create_dt: string
}

export interface SportsLiveListType {
    sourceType  : number
    sports      : string
    title       : string
    home_name   : string
    away_name   : string
    title_color : string
    seq         : string
    code        : string
    time        : string
    date        : string
    states      : string
    leagueName  : string
    thumbnail   : string
    home_color  : string
    away_color  : string
    video       : string
    video_src   : string
}

export interface folder10ListType {
    away_team: string
    game_time: string
    game_type: string
    home_team: string
    league_name: string
    match_result: number
    match_result_display: string
    match_result_type: string
}

export interface AnalysisListTypes {
    id: number,
    title: string,
    author_name: string,
    content: string,

    game_time: string,
    game_type: number,
    game_type_display: string,
    league_name: string,
    region_name: string,

    home_team: string,
    away_team: string,
    home_team_logo: string,
    away_team_logo: string,

    match_result: matchResultType,
    handicap_result: handicapResultType,
    under_over_result: underOverResultTypes,

    create_dt: string,
    update_dt: string,
}
export interface matchResultType {
    match_result: string,
    odds: number
}
export interface handicapResultType {
    handicap_result: string,
    odds: number,
    handicap_score: string
}
export interface underOverResultTypes {
    under_over_result: string,
    odds: number,
    under_over_score: number
}

export type addViewCountTypes = `ana` // 스포츠 분석, 
    | `comm` // 커뮤니티
    | `evb`  // 이벤트
    | `evm`  // 이벤트 매치
    | `noti` // 공지사항
    | `spec` // 실시간 팩트
    | `veri` // 스폰업체

export interface sportsNewsTypes {
    id                 : number
    board_type         : number
    board_type_display : string
    title              : string
    content            : string
    author_name        : string
    create_dt          : string
    update_dt          : string
}